import { SummaryData } from '../types';

interface SummaryCardProps {
    summary: SummaryData;
}

/**
 * SummaryCard - Displays a single summary as a card
 */
export function SummaryCard({ summary }: SummaryCardProps) {
    const { content, error } = summary;

    if (error || !content) {
        return null;
    }

    return (
        <div className="weavable-card">
            <div className="weavable-card-content" dangerouslySetInnerHTML={{ __html: content }} />
        </div>
    );
}
